import styles from './PromoBlockContent.module.scss';

const PromoBlockContent = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.right_container}>{children}</div>;
};

export default PromoBlockContent;
